module.exports = __webpack_public_path__ + "img/rtb-go-header-img.a3c1ffbc.png";